var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegistryReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1583 5.0812L16.5009 0.839835L15.7776 0H7.13682C5.97686 0 5.03857 0.939624 5.03857 2.10026V4.76911H6.33918L6.33851 2.61126C6.33985 1.95828 6.86491 1.42986 7.51589 1.42986L14.9056 1.42317V4.92449C14.907 6.22844 15.9605 7.28393 17.2657 7.28393H19.8234L19.6975 17.3841C19.6955 18.0337 19.1684 18.5581 18.5195 18.5634L7.42213 18.5581C6.82808 18.5581 6.3499 17.9754 6.34722 17.2575V16.4022H5.0446V17.6774C5.0446 18.9579 5.90319 20 6.95734 20L18.8992 19.9973C20.0592 19.9973 21.0001 19.053 21.0001 17.8951V6.059L20.1583 5.0812Z",
    fill: "#434440"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.4774 17.0542H0.933594V4.11914H14.4774V17.0542ZM2.23487 15.7523H13.1735V5.42109H2.23487",
    fill: "#08743B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.4682 13.9994H9.18775L7.63131 11.8001L5.99718 13.9994H3.70605L6.54837 10.4258L4.25322 7.29883H6.56712L7.64136 8.99859L8.78659 7.29883H11.1413L8.73502 10.4258L11.4682 13.9994Z",
    fill: "#08743B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistryReport);
export default __webpack_public_path__ + "static/media/Registry_Report.13c5fb1bda91dc070963743e8ccaba58.svg";
export { ForwardRef as ReactComponent };